import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { FolderTree, Search, Globe } from 'lucide-react';
import { useCategories } from '@/hooks/use-categories';

/** FR-98: as Lovable — product categories come from the global catalog, read-only for the merchant. */
export default function Categories() {
  const { t } = useTranslation();
  const { data: categories = [], isLoading } = useCategories();
  const [search, setSearch] = useState('');

  const filteredCategories = categories.filter((cat) =>
    !search || String(cat.name).toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-6 max-w-3xl mx-auto animate-fade-in">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <FolderTree size={20} className="text-primary" />
          <h1 className="text-xl font-semibold text-foreground">{t('cat_categories.title')}</h1>
        </div>
        <span className="text-xs text-muted-foreground">{t('cat_categories.total', { n: categories.length })}</span>
      </div>

      <p className="flex items-center gap-1.5 text-xs text-muted-foreground mb-4">
        <Globe size={12} /> {t('cat_categories.globalNote')}
      </p>

      <div className="relative max-w-xs mb-4">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input placeholder={t('cat_common.search')} value={search} onChange={e => setSearch(e.target.value)} className="pl-9" />
      </div>

      <div className="bg-card border border-border rounded-xl overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border bg-muted/50">
              <th className="text-left text-xs font-medium text-muted-foreground p-3">{t('cat_common.name')}</th>
              <th className="text-right text-xs font-medium text-muted-foreground p-3">{t('cat_categories.source')}</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr><td colSpan={2} className="p-8 text-center text-muted-foreground">{t('cat_common.loading')}</td></tr>
            ) : filteredCategories.length === 0 ? (
              <tr><td colSpan={2} className="p-8 text-center text-muted-foreground">{t('cat_categories.notFound')}</td></tr>
            ) : (
              filteredCategories.map((cat) => (
                <tr key={cat.id} className="border-b border-border last:border-0 hover:bg-muted/30 transition-colors">
                  <td className="p-3 text-sm font-medium text-foreground">{cat.name}</td>
                  <td className="p-3 text-right text-xs text-muted-foreground">{t('cat_categories.globalCatalog')}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
